import RichEditorCommon, { type RichEditorProps as RichEditorPropsCommon } from "@common/components/Inputs/RichEditor";
import React from "react";
import { getToolbar, type RichEditorToolbar } from "./lib";
import "./style.less";

export * from "@common/components/Inputs/RichEditor";

type RichEditorProps = Omit<RichEditorPropsCommon, "modalsClassName" | "toolbar"> & {
  isAdmin: boolean;
  toolbar?: RichEditorToolbar;
};
const RichEditor = ({ isAdmin, toolbar, ...props }: RichEditorProps) => (
  <RichEditorCommon
    {...props}
    dropdownClassName={isAdmin ? "admin _theme_" : undefined}
    minHeight={props.isInline ? undefined : 120}
    toolbar={getToolbar(toolbar, isAdmin)}
  />
);
export default RichEditor;
